import { Worklog } from "../worklogs/worklogs.model";
import { AttachmentHolder, AttachmentInfo } from "../core/shared/attachments/attachments.model";

export class IssueRow {
    id: number;
    fullTitle: string;
    customerCode: string;
    createdDate: Date;
    projectFullName: string
}

export class Issue implements AttachmentHolder {
    attachments: AttachmentInfo[];
    id: number;
    issueType: string;
    departmentId: number;
    customerId: number;
    customerCode: string;
    reporterId: number;
    assigneeId: number;
    assigneeName: string;
    title: string;
    systemVersionId: number;
    startDate: Date  = new Date();
    endDate: Date;
    budget: number;
    timeBudget: number;
    priority = 2;
    isInternal = false;
    objectTypeId: number;
    //projectId: number;
    projectName: string;
    projectStepId: number;
    projectStepName: string;
    objectStateId: number;
    payed = false;
    tfsId: number;
    description: string;
    htmlDescripiton: string;
    isToTfs = false;
    areaPathId: number;
    isPublic = false;
    planningWorkTime = 0;
    previousAssigneeId: number;
    author: string;
    userStoryId: number;
    userStoryName: string;
    comarchId: string;
    functionalityId: number;
    assignedTo: string;
    elementAssignee: string;
    notAssignedIssue = false;

    issueElements: IssueElement[];
    issueWatchers: IssueWatcher[];
    issueRelations: IssueRelation[];
    worklogs: Worklog[];
}

export class IssueRelation {
    id: number;
    parentId: number;
    childId: number;
    childTitle: string;
    childStartDate: Date;
    childEndDate: Date;
    childBudget: number;
    childTimeBudget: number;
    childWorklogsTimeSpent: number;
    childDescription: string;
}

export class IssueElement {
    id: number;
    issueId: number;
    employeeId: number;
    description: string;
    objectTypeId: number;
    objectStateId: number;
    isInternal = true;
    emailConfirmation: number;
    htmlDescripiton: string;
    isSynchronizedToTfs: boolean;
    isFromTfs: boolean;
    assignedTo: string;
    stateTranslation: string;
    createdDate: Date = new Date();
    createdBy: string;
    employeeFullName: string;
    isNew = true;
    autoForNotAssigned = false;
}

export class IssueWatcher {
    id: number;
    issueId: number;
    employeeId: number;
    employeeFullName: string;
    isFromProject: boolean;
}

export class ChangeStateEntity {
    ids: number[];
    objectStateId: number;
    isSendEmail: boolean;
    description: string;
}
